/**
 * Asynchronously loads the component for AdminCourses
 */

import { lazyLoad } from "utils/loadable";

export const AdminCourses = lazyLoad(
  () => import("./index"),
  (module) => module.AdminCourses
);